<template>
    <div>
        <div class="menu-item-left last5" :class="{isTpg:isTpg}">

            <div class="left-menu-item-header menu-border-top">
                <b>Last Tracks</b>
                <!-- <span v-if="selectedPlayerTitle && selectedPlayerTitle.length > 20"
                                  v-tooltip="selectedPlayerTitle" class="selectedPlayerTitle">{{ selectedPlayerTitle }}</span>
                            <span v-else>{{ selectedPlayerTitle }}</span> -->
            </div>

            <div v-if="lastFiveTracks">
                <div class="last5-row" v-for="track in lastFiveTracks" :class="{isTpg:isTpg}" v-bind:key="track.code">
                    <div class="last5-image" :class="{isTpg:isTpg}">
                        <img :src="track.album.cover" onerror="this.onerror=null;this.src='/images/unknown-album.jpg';" v-if="track">
                    </div>
                    <div class="last5-track" v-if="track">
                        {{ track.title }} - {{ track.artist.name }}
                    </div>
                    <div class="last5-vote" v-if="track && showVotingLink() == true && itMode == false && selectedPlayer.isShutdown != '1'">
                        <div class="vote-love" v-on:click="voteClicked(track,1,track.votes.vote)" :class="{voteSelected: track.votes.vote == '1', isTpg:isTpg}" v-if="itMode == false"></div>
                        <div class="vote-leave" v-on:click="voteClicked(track,0,track.votes.vote)" :class="{voteSelected: track.votes.vote == '0', isTpg:isTpg}" v-if="itMode == false"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const Querystring = require('querystring');

export default {
  data() {
    return {
      pathToUnknownImage: '../../../assets/images/unknown-album.jpg',
    };
  },
  props: ['user-info', 'latest-track', 'selected-player', 'is-tpg', 'tracks'],
  mounted() {},
  methods: {
    /**
     * Handle vote click.
     * 
     * T237 Modified (02-18-2022)
     *
     * @param object track, int loveOrLeave (love=1, leave=0)
     * @return this.makeVote()
     */
    voteClicked(track, loveOrLeave, oldVote) {
      if (this.selectedPlayer && this.selectedPlayer != null) {

        // If already voted, delete first.
        if (oldVote == '0' || oldVote == '1') {
          const self = this;
          // WSL type - T686 (05-26-2022)
          if (this.selectedPlayer.playerTypeId == '4') {
            this.$http.delete(`/location_zone/vote/${this.selectedPlayer.fId()}/${track.code}`).then(() => {
              if (oldVote != loveOrLeave) {
                self.makeVote(track, loveOrLeave);
              } else {
                track.vote = null;
              }
            });
          } else { // All other Types (physical/virtual/instore)
            this.$http.delete(`/v3/vote/${this.selectedPlayer.playerTypeId}/${this.selectedPlayer.fId()}/${track.code}`).then(() => {
              if (oldVote != loveOrLeave) {
                self.makeVote(track, loveOrLeave);
              } else {
                track.votes.vote = null;
              }
            });
          }
        } else {
          this.makeVote(track, loveOrLeave);
        }
      }
    },
    /**
     * Send POST API for vote.
     * 
     * T237 Modified (02-18-2022)
     * T686 Modified (05-26-2022)
     *
     * @param object track, int loveOrLeave (love=1, leave=0)
     * @set this.lastFiveTracks
     */
    makeVote(track, loveOrLeave) {
      let loveLeaveString = '';
      if (loveOrLeave == '1') {
        loveLeaveString = 'positive';
      } else if (loveOrLeave == '0') {
        loveLeaveString = 'negative';
      }

      const self = this;

      // WSL type - T686 (05-26-2022)
      if (this.selectedPlayer.playerTypeId == '4') {
        const trackVote = Querystring.stringify({
          location_zone_player_id: this.selectedPlayer.fId(),
          overrideVoteType: loveLeaveString,
          station_code: this.selectedPlayer.stationCode,
          track_code: track.code 
        });

        this.$http.post(`/v1/station/vote`, trackVote).then(() => {
          track.votes.vote = loveOrLeave;
          if (loveOrLeave == 1) {
            self.$wkToast("Got Your 'Love It' Vote");
          } else {
            self.$wkToast("We get it, you don't like this track.  No worries, now it's off your playlist.");
            loveLeaveString = 'Leave';
          }
        });
      } else { // All other Types (physical/virtual/instore)
        const trackVote = Querystring.stringify({ overrideVoteType: loveLeaveString });

        this.$http.post(`/v3/vote/${this.selectedPlayer.playerTypeId}/${this.selectedPlayer.fId()}/${track.code}`, trackVote).then(() => {
          track.votes.vote = loveOrLeave;
          if (loveOrLeave == 1) {
            self.$wkToast("Got Your 'Love It' Vote");
          } else {
            self.$wkToast("We get it, you don't like this track.  No worries, now it's off your playlist.");
            loveLeaveString = 'Leave';
          }
        });
      }

      const event_data = {
        web_tracking_event_type_id: 1,
        page_name: 'Menu - Last 5',
        location_zone_id: this.selectedPlayer.locationZoneId,
        track_code: track.code,
        contact_login_station_id: '',
        vote_value: loveOrLeave,
      };
      this.$emit('logEvent', event_data);
    },
    /**
     * Only show voting link if userInfo has serviceOption as Voting.
     *
     * @return true if service option true
     */
    showVotingLink() {
      if (this.userInfo) {
        const serviceOptions = this.userInfo.service_options;
        if (serviceOptions) {
          for (let i = 0; i < serviceOptions.length; i++) {
            if (serviceOptions[i].service_option_id == '11' && serviceOptions[i].service_option_type_id == '3') {
              return true;
            }
          }
        }
      }

      return false;
    },
  },
  computed: {
    itMode() {
      const serviceOptions = this.userInfo.service_options;
      for (let i = 0; i < serviceOptions.length; i++) {
        if (serviceOptions[i].service_option_id == '16' || serviceOptions[i].service_option_id == 16) {
          return true;
        }
      }

      return false;
    },
    selectedPlayerTitle() {
      if(this.selectedPlayer.esTitle) {
        return this.selectedPlayer.esTitle;
      }

      return '-';
    },
    locationName() {
      const location = this.selectedLocation;

      if (location && location.name) {
        return location.name;
      }

      return '-';
    },
    locationZoneName() {
      const locationZone = this.selectedLocationZone;

      if (locationZone && locationZone.name) {
        return locationZone.name;
      }

      return '-';
    },
    allowVoting() {
      if (this.userInfo.service_options) {
        const serviceOptions = this.userInfo.service_options;

        for (let i = 0; i < serviceOptions.length; i++) {
          if (serviceOptions[i].service_option_name == 'Voting') {
            return true;
          }
        }
      }

      return false;
    },
    lastFiveTracks() {
      if (!this.tracks) {
        return;
      }

      return this.tracks;
    },
  },
  watch: {
    // userInfo: function() {
    //     var serviceOptions = this.userInfo.service_options;
    //     for (var i = 0; i < serviceOptions.length; i++) {
    //         if (serviceOptions[i].service_option_name == "IT Only") {
    //             this.itMode = true;
    //         }
    //     }
    // },
  },
};

</script>

<style scoped>
.last5 {
    padding-bottom: 8px;
}

.last5-row {
    margin-top: 0px;
    height: 42px;
    border-bottom: 1px solid #919191;
    clear: both;
}

.last5-row.isTpg {
    border-bottom: 1px solid #ccc;
}

.last5-row:last-child {
    border-bottom: 0px
}

.last5-image {
    float: left;
    margin-top: -16px;
    width: 34px;
}

.last5-image.isTpg {
    margin-top: -16px;
}

.last5-image img {
    margin-top:20px;
    height: 34px;
    width: 34px;
}

.last5-track {
    float: left;
    width: 230px;
    padding-left: 15px;
    line-height: 40px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 12px;
}

.last5-vote {
    text-align: right;
    float: right;
    width: 62px;
    padding-top: 6px;
}

@media (max-width: 768px) {
    .last5-track {
        width: 160px;
        padding-left: 5px;
    }
}

.icon {
    display: inline-block;
    width: 1em;
    height: 1em;
    stroke-width: 0;
    stroke: yellow;
    fill: yellow;
    border: 1px solid yellow;
}

.icon-heart {
    width: 1.15625em;
}

.left-menu-item-header {
    font-size: 16px;
}

.menu-item-left {
    min-height: 50px;
    line-height: 50px;
    padding: 0 20px 0px 20px;
}

.menu-border-top {
    padding-top: 5px;
}

</style>
